import { gql } from '@apollo/client/core';

// Announcements are broadcast school-wide by admins. The backend already
// exposes these operations; the client just surfaces them (see #223).

export const ACTIVE_ANNOUNCEMENTS = gql`
  query ActiveAnnouncements {
    activeAnnouncements {
      id
      title
      body
      severity
      dismissible
      requires_ack
      cta_label
      cta_url
      display_from
      display_until
      published_at
    }
  }
`;

export const ACKNOWLEDGE_ANNOUNCEMENT = gql`
  mutation AcknowledgeAnnouncement($announcement_id: ID!) {
    acknowledgeAnnouncement(announcement_id: $announcement_id)
  }
`;

export const DISMISS_ANNOUNCEMENT = gql`
  mutation DismissAnnouncement($announcement_id: ID!) {
    dismissAnnouncement(announcement_id: $announcement_id)
  }
`;
